import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { STATUS_TYPES } from "../../../constants";
import { IUserTypes } from "../../../types/contacts";
import { extractParseName, extractShortName, formatCellphone } from "../../../utils";
import { Badge } from "reactstrap";

interface ChatUserProps {
  user: IUserTypes;
  unreadCount: number;
  selectedChat: number;
  onSelectChat: (id: number) => void;
}

const ChatUser = ({ user, selectedChat, unreadCount, onSelectChat }: ChatUserProps) => {

  // console.log("RENDER ChatUser", user.id);

  const isSelectedChat = selectedChat === user.id;
  const fullName = user.name;// || `${user.firstName} ${user.lastName}`;

  const colors = [
    "bg-primary",
    "bg-danger",
    "bg-info",
    "bg-warning",
    "bg-secondary",
    "bg-pink",
    "bg-purple",
  ];

  let { firstName, lastName } = extractParseName(fullName);
  let { shortName } = extractShortName(firstName, lastName);
  const phoneNumber = user.phoneNumber;

  // const [color] = useState(Math.floor(Math.random() * colors.length));
  const color = useMemo(() => Math.floor(Math.random() * colors.length), []);
  const isOnline = STATUS_TYPES.ACTIVE;
  const lastTimeMessage = user.lastMessageTime;

  // DEFINIÇÃO DAS CORES DO BADGE
  const getBadgeColor = () => {
    if (unreadCount >= 6) return "danger";
    if (unreadCount >= 3) return "warning";
    return "secondary";
  };

  return (
    <li className={classnames({ active: isSelectedChat })} onClick={() => onSelectChat(user.id)}>
      <Link to="#" className={classnames({ "unread-msg-user": unreadCount > 0 })}>
        <div className="d-flex align-items-center">
          <div
            className={classnames(
              "chat-user-img",
              "align-self-center",
              "me-2",
              "ms-0",
              { online: isOnline }
            )}
          >
            {user.avatar ? (
              <>
                <img
                  src={user.avatar}
                  className="rounded-circle avatar-xs"
                  alt={fullName}
                />
                {isOnline && <span className="user-status"></span>}
              </>
            ) : (
              <div className="avatar-xs">
                <span
                  className={classnames(
                    "avatar-title",
                    "rounded-circle",
                    "text-uppercase",
                    "text-white",
                    colors[color]
                  )}
                >
                  {shortName}
                  {isOnline && <span className="user-status"></span>}
                </span>
              </div>
            )}
          </div>
          <div className="overflow-hidden">
            <div className="flex-grow-1">
              <p className="text-truncate mb-0">{fullName}</p>
              <small className="text-muted mt-n5">{formatCellphone(phoneNumber as string)}</small>
            </div>
          </div>
          {unreadCount > 0 && (
            // <div className="ms-auto">
            //   <span className="badge badge-soft-light rounded p-1">{unRead}</span>
            // </div>
            <div className="ms-auto ">
              <Badge color={getBadgeColor()} pill className="rounded-circle d-flex justify-content-center align-items-center p-1">
                {unreadCount}
              </Badge>
            </div>

          )}
        </div>
      </Link>
    </li>
  );
};

// export default ChatUser;

// export default React.memo(ChatUser, (prev, next) => {
//   return (
//     prev.user.id === next.user.id &&
//     prev.selectedChat === next.selectedChat &&
//     prev.unreadCount === next.unreadCount
//   );
// });

export default React.memo(ChatUser, (prev, next) => {
  return (
    prev.user.id === next.user.id &&
    prev.user.lastMessageTime === next.user.lastMessageTime &&
    prev.user.unreadCount === next.user.unreadCount &&
    prev.selectedChat === next.selectedChat
  );
});